<template>
  <el-dialog
    :visible="true"
    :before-close="handleClose"
    :title="$t('自校准')"
    width="500px"
    class="self-cleaning"
    top="30vh"
  >
    <HTForm v-bind="formOptions" :i18nPath="i18nPath"></HTForm>
  </el-dialog>
</template>

<script>
import HTForm from '@/components/form/index.vue';
import { getSensorList, selfCalibration } from '@/api/devices';
import { awaitTo } from '@/utils/utils';
import { isEmpty, isObject } from '@/utils/is';
import { subscribe } from '@/utils/mqtt';

export default {
  components: {
    HTForm
  },
  props: {
    sn: {
      type: String,
      default: ''
    },
    container: {
      type: HTMLElement,
      default: () => document.body
    }
  },
  data() {
    return {
      i18nPath: 'part',
      formOptions: {
        inline: true,
        config: {
          labelWidth: '',
          span: 24,
          options: [
            {
              span: 18,
              type: 'select',
              prop: 'sensorSeq',
              labelNeedTranslation: true,
              dataKey: 'sensorList',
              placeholder: '请选择',
              label: '传感器列表'
            }
          ],
          operation: {
            span: 6,
            buttons: [
              {
                text: '确定',
                loading: false,
                type: 'primary',
                handler: async ({ data, setLoading, getFormRef }) => {
                  const formRef = getFormRef();

                  const valid = await formRef.validate();

                  if (!valid) return false;

                  setLoading(true);

                  const [err, res] = await awaitTo(
                    selfCalibration({
                      sn: this.sn,
                      sensorSeq: +data.sensorSeq
                    })
                  );

                  setLoading(false);

                  if (err) return console.log(err);

                  if (res.code === 200) {
                    const notifyWindow = this.$notify.info({
                      title: this.$t('提示'),
                      message: this.$t('自校准中'),
                      duration: 0
                    });

                    const text = this.$t('自校准完成');

                    const stop = subscribe(
                      `{prefix}/{userId}/selfCalibrationComplete/${this.sn}/`,
                      () => {
                        notifyWindow.close?.();
                        this.$message.success(text);
                        stop();
                      }
                    );

                    this.handleClose();
                  }
                }
              }
            ]
          }
        },

        model: {
          sensorSeq: 1
        },
        dataSource: {
          sensorList: []
        },
        rules: {
          sensorSeq: [
            {
              required: true,
              validator: (_rule, value, callback) => {
                if (isEmpty(value)) {
                  callback(this.$t('请选择传感器'));
                } else {
                  callback();
                }
              },
              trigger: 'blur'
            }
          ]
        }
      }
    };
  },
  methods: {
    handleClose(done) {
      this.$destroy();
      done?.();
    },
    async loadData() {
      const [err, res] = await awaitTo(getSensorList(this.sn));

      if (err) {
        console.log(err);
        return;
      }

      if (isObject(res?.data) && !isEmpty(res?.data)) {
        this.formOptions.dataSource.sensorList = Object.keys(res.data).map(key => ({
          label: res.data[key],
          value: key
        }));

        this.formOptions.model.sensorSeq = Object.keys(res.data)[0];
      }
    }
  },
  mounted() {
    document.body.appendChild(this.$el);

    this.loadData();
  },
  destroyed() {
    // if appendToBody is true, remove DOM node after destroy
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  }
};
</script>

<style lang="scss">
.sell-cleaning {
  box-sizing: border-box;

  .el-dialog {
    height: calc(100vh - 20vh);

    &__body {
      height: calc(100% - 55px);
      box-sizing: border-box;
    }

    .m-table {
      height: calc(100% - 60px);

      .el-table {
        height: calc(100% - 55px);

        &__body-wrapper {
          height: calc(100% - 48px);
        }
      }
    }
  }
}
</style>
